/**
 * Footer Component
 * Modern footer with BookBridge branding and links
 */

import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-navy text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-12 h-12 bg-gradient-to-br from-indigo-600 to-purple-600 rounded-xl flex items-center justify-center">
                <span className="text-white text-xl font-bold">B</span>
              </div>
              <span className="text-2xl font-bold">BookBridge</span>
            </div>
            <p className="text-white/70 text-lg leading-relaxed max-w-md">
              The missing OAuth + accounting API layer between your app and BookBridge Online. 
              Streamline your integration today.
            </p>
          </div>

          {/* Links */}
          <div>
            <h3 className="font-bold text-lg mb-6">Product</h3>
            <ul className="space-y-4">
              <li>
                <a 
                  href="https://api-xcelerateai.demotrt.com/api-docs/" 
                  target="_blank" 
                  rel="noreferrer"
                  className="text-white/70 hover:text-white transition-colors"
                >
                  Documentation
                </a>
              </li>
              <li>
                <a href="#features" className="text-white/70 hover:text-white transition-colors">
                  Features
                </a>
              </li>
              <li>
                <a href="#api" className="text-white/70 hover:text-white transition-colors">
                  API
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-bold text-lg mb-6">Legal</h3>
            <ul className="space-y-4">
              <li>
                <Link to="/privacy" className="text-white/70 hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-white/70 hover:text-white transition-colors">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/60 text-sm">
            © {new Date().getFullYear()} BookBridge. All rights reserved.
          </p>
          <p className="text-white/60 text-sm">
            Built for BookBridge integration
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
